(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hg-band-globe"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hg-band-globe')) {
  customElements.define('hg-band-globe', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const el = this.querySelector('.hg-band-globe');
      const nodes = Array.from(this.querySelectorAll('.hg-globe-mark'));
      const reservoir = this.querySelector('.hg-globe-reservoir');
      const count = Math.min(60, nodes.length);
      const slots = Array.from({length: count}, () => {
        const slot = document.createElement('div');
        slot.className = 'hg-globe-slot'; slot.style.visibility = 'hidden'; el.append(slot); return slot;
      });
      const indices = slots.map((_,i) => i), priorZ = slots.map(() => 0);
      const attach = (i) => { slots[i].append(nodes[indices[i]]); nodes[indices[i]].hidden = false; };
      slots.forEach((_,i) => attach(i));
      let angle = 0, last = 0, frame = 0, visible = false, hover = false, paused = false;
      let width = el.clientWidth, height = el.clientHeight;
      const button = this.querySelector('[data-hg-toggle]');
      const video = this.querySelector('video');
      const media = matchMedia('(prefers-reduced-motion: reduce)');
      const reduced = () => media.matches;
      const videoState = () => {
        if (!video) return;
        video.muted = true; video.playbackRate = .4; video.defaultPlaybackRate = .4;
        if (visible && !paused && !reduced() && !document.hidden) video.play().catch(() => {}); else video.pause();
      };
      const labels = () => { button.textContent = paused || reduced() ? this.dataset.resume : this.dataset.pause; button.setAttribute('aria-pressed', String(paused || reduced())); };
      const draw = (time) => {
        frame = 0;
        const dt = last ? Math.min(time-last,50) : 0; last = time;
        if (visible && !document.hidden) {
          if (!paused && !reduced() && !hover && !el.contains(document.activeElement)) angle += dt*.00006;
          slots.forEach((slot,i) => {
            const y=1-2*(i+.5)/count, radial=Math.sqrt(1-y*y), theta=i*Math.PI*(3-Math.sqrt(5))+angle;
            const x=Math.cos(theta)*radial, z=Math.sin(theta)*radial;
            if (Math.sin(theta)<-.85 && priorZ[i]>=-.85) {
              nodes[indices[i]].hidden=true; reservoir.append(nodes[indices[i]]);
              indices[i]=indices[i]+count<nodes.length?indices[i]+count:i; attach(i);
            }
            priorZ[i]=Math.sin(theta);
            slot.style.transform=`translate(-50%,-50%) translate(${x*width*.42}px,${y*height*.42}px) scale(${.62+.38*(z+1)/2})`;
            slot.style.opacity=String(z<-.12?0:Math.min(1,(z+.12)*2.7));
            slot.style.zIndex=String(Math.round((z+1)*100)); slot.style.visibility=z<-.12?'hidden':'visible';
            if (z>=-.12) {
              const img=nodes[indices[i]].querySelector('image[data-hg-src]');
              if (img) { img.setAttribute('href', img.dataset.hgSrc); img.removeAttribute('data-hg-src'); }
            }
          });
        }
        if (visible && !document.hidden && !paused && !reduced() && !hover && !el.contains(document.activeElement)) frame=requestAnimationFrame(draw);
      };
      const schedule=()=>{last=0;if(!frame)frame=requestAnimationFrame(draw);};
      const sync=()=>{labels();videoState();schedule();};
      const toggle=()=>{paused=!paused;sync();};
      const enter=e=>{if(e.pointerType==='mouse')hover=true;};
      const leave=()=>{hover=false;schedule();};
      const observer=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;videoState();schedule();});observer.observe(this);
      const resize=new ResizeObserver(()=>{width=el.clientWidth;height=el.clientHeight;schedule();});resize.observe(el);
      button.addEventListener('click',toggle);el.addEventListener('pointerenter',enter);el.addEventListener('pointerleave',leave);el.addEventListener('focusout',schedule);
      document.addEventListener('visibilitychange',sync);media.addEventListener('change',sync);sync();
      this.cleanup=()=>{cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();video?.pause();button.removeEventListener('click',toggle);el.removeEventListener('pointerenter',enter);el.removeEventListener('pointerleave',leave);el.removeEventListener('focusout',schedule);document.removeEventListener('visibilitychange',sync);media.removeEventListener('change',sync);nodes.forEach(n=>{n.hidden=true;reservoir.append(n);});slots.forEach(s=>s.remove());};
    }
    disconnectedCallback(){this.cleanup?.();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-store-map"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hg-store-map')){
  customElements.define('hg-store-map',class extends HTMLElement{
    connectedCallback(){
      this.querySelector('[data-hg-load-map]')?.addEventListener('click',()=>{
        const frame=this.querySelector('[data-hg-map]');
        const map=document.createElement('iframe');
        map.title=frame.dataset.title;
        map.src='https://www.google.com/maps?q=Drottninggatan%2088A%2C%20111%2036%20Stockholm%2C%20Sweden&z=16&output=embed';
        map.loading='lazy';map.referrerPolicy='no-referrer-when-downgrade';map.allowFullscreen=true;
        frame.replaceChildren(map);frame.classList.add('hg-map-loaded');
      },{once:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
